import ShowMoreComment from './show-more-comment';

export default ShowMoreComment;
